import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdInterface, ProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetProductUseCaseParams {
    productCode: IdInterface;
}

@Injectable()
export class GetProductUseCase implements UseCaseWithParam<GetProductUseCaseParams, Observable<Transaction<ProductInterface>>> {
    constructor(private productProvider: ProductProvider) {}

    bind(params: GetProductUseCaseParams): Observable<Transaction<ProductInterface>> {
        return this.productProvider.detail(params.productCode);
    }
}
